// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","646":"component---src-pages-chat-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"26c551dbb90f59ca43a1","646":"944833d1f1490ca639e7","678":"710a706b9a86e884b789","883":"a7e7518b3ac69f172c50"}[chunkId] + ".js";
};